import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import './field.scss';

import { GeckoField, GECKO_UTILS, GeckoBtn } from 'ui';

class EditableValueField extends Component {
  constructor(props) {
    super(props);
    this.state = {
      values: props.values,
    };
    this.handleClick = this.handleClick.bind(this); // ensure it is the same reference so the removeListener works properly
  }

  componentDidMount() {
    const formNode = ReactDOM.findDOMNode(this.formElem);
    const input = formNode.querySelector('input');
    if (input) {
      input.focus();
    }
    document.addEventListener('mousedown', this.handleClick);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClick);
  }

  handleClick(event) {
    if (
      this.formElem &&
      !this.formElem.contains(event.target) &&
      event.target.className.indexOf('Select-option') === -1 &&
      event.target.className.indexOf('Select-value-icon') === -1 &&
      event.target.className.indexOf('Select-clear') === -1
    ) {
      this.props.stopEditting();
    }
  }

  handleChange(key, val) {
    const newValues = GECKO_UTILS.setNestedValue(this.state.values, key, val);
    this.setState({ values: newValues });
  }

  submitValue(e) {
    if (e) {
      e.preventDefault();
    }
    const key = this.props.field.key;
    const value = GECKO_UTILS.getNestedValue(this.state.values, key);
    this.props.submitValue(key, value);
    this.props.stopEditting();
  }

  render() {
    return (
      <div className="EditableValueField">
        <form
          ref={(elem) => (this.formElem = elem)}
          onSubmit={this.submitValue.bind(this)}
        >
          <GeckoField
            field={this.props.field}
            values={this.state.values}
            handler={this.handleChange.bind(this)}
          />
          <div className="d-flex justify-content-end" style={{ marginTop: 16 }}>
            <GeckoBtn
              icon="far fa-times"
              handler={this.props.stopEditting}
              name="Cancel"
              type="outline-primary"
              size="sm"
            />
            {this.props.submitValue ? (
              <div style={{ marginLeft: 8 }}>
                <GeckoBtn
                  icon="far fa-check-double"
                  handler={this.submitValue.bind(this)}
                  name="Save"
                  preset="save"
                  size="sm"
                />
              </div>
            ) : null}
          </div>
        </form>
      </div>
    );
  }
}

export default EditableValueField;
